/**
 * Copyright (c) 2023, WSO2 LLC. (https://www.wso2.com). All Rights Reserved.
 *
 * WSO2 LLC. licenses this file to you under the Apache License,
 * Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied. See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import { Box, Container, Grid, Typography } from "@mui/material";
import React from "react";
import Constants from "../constants";
import { useCloud } from "../Hooks/Cloud";

/**
 * Legend component
 * Description: This component is used to display the legend.
 */
function Legend() {
  const { cloud } = useCloud();
  const features = window.ENV[cloud].features;

  return (
    features.legend &&
    (<Container sx={ { my: 4 } }>
      <Box>
        <Grid container>
          { Constants.legends.map((item, index) => {
            return (
              <Grid item key={ index } xs sm md lg sx={ { p: 1 } }>
                <Typography component="span" variant="body2">
                  <Box sx={ { alignItems: "center", display: "flex" } }>
                    <item.icon sx={ { color: item.color, fontWeight: 0.5 } } />
                    <Box component="span" sx={ { pl: 0.5 } }>
                      { item.title }
                    </Box>
                  </Box>
                </Typography>
              </Grid>
            );
          }) }
        </Grid>
      </Box>
    </Container>
    ));
}

export default Legend;
